module.exports = __webpack_public_path__ + "5017c243325f7a5aa8479b3441977c10.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/burrito.png
// module id = 2495
// module chunks = 0